import { render, staticRenderFns } from "./ClientInsurance.vue?vue&type=template&id=4bc44a4a"
import script from "./ClientInsurance.vue?vue&type=script&lang=js"
export * from "./ClientInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports